export interface LanguageModel {
  id: number;
  name: string;
  nativeName: string;
  isoTwoLetterName: string;
  isoTwoLetterCode: string;
  isoThreeLetterName: string;
  cultureCode: string;
  isRtl: boolean;
}
